import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const DatePickerFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('DatePickerField'),
});

export type DatePickerField = z.infer<typeof DatePickerFieldSchema>;